import join from 'url-join';
import { useOptimizely } from '@libs/common-next';
import css from './new.module.scss';

export function New() {
    const { instance } = useOptimizely();

    return (
        <div className={css.add}>
            <p>Add feature flag</p>
            <span>Learn how to set up and rollout a new feature flag in the Optimizely dashboard.</span>
            <a
                target="_blank"
                href={join(
                    ' https://app.optimizely.com/v2/projects',
                    `${instance?.getProjectConfig()?.projectId}`,
                    'flags/list'
                )}
            >
                Set up
            </a>
        </div>
    );
}
